import { Analyst } from '@analysis/domain';
import type { AnalystRepository, AuthContext, FeatureFlags, FetchAnalystsOptions } from '../../ports';

export interface FetchSampleAnalystsParams {
  sampleId: string;
}

export class FetchSampleAnalystsUseCase {
  constructor(
    private readonly analystRepository: AnalystRepository,
    private readonly featureService: FeatureFlags,
    private readonly authService: AuthContext
  ) {}

  async execute(params: FetchSampleAnalystsParams): Promise<Analyst[]> {
    const currentUser = this.authService.currentUser;
    if (!currentUser) {
      throw new Error('Current user is not available');
    }

    const canUseManagerReview = this.featureService.canUse('analysisReview', 'manager_review');
    const canUseReview = this.featureService.canUse('analysisReview');
    const canUseAI = this.featureService.canUse('ai');
    const isAnalystManager = this.authService.currentUserRoleNames.includes('analystmanager');

    const options: FetchAnalystsOptions = {
      canUseManagerReview,
      canUseReview,
      canUseAI,
      isAnalystManager,
      currentUserId: currentUser.id,
    };

    return this.analystRepository.fetchForSample(params.sampleId, options);
  }
}
